module.exports = __webpack_public_path__ + "static/media/team1.910de427.png";